var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg111PowerButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257,276c11.046,0,20-8.954,20-20V20c0-11.046-8.954-20-20-20s-20,8.954-20,20v236C237,267.046,245.954,276,257,276z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.738,440.894C334.143,461.244,295.505,472,256,472c-119.103,0-216-96.897-216-216 c0-90.988,57.746-172.629,143.693-203.153c10.409-3.697,15.85-15.131,12.153-25.54s-15.132-15.85-25.54-12.153 c-49.382,17.538-91.687,49.3-122.342,91.854C16.586,150.565,0,202.086,0,256c0,68.38,26.628,132.667,74.98,181.02 C123.333,485.371,187.62,512,256,512c46.813,0,92.617-12.757,132.462-36.893c9.447-5.723,12.467-18.021,6.744-27.468 C389.483,438.19,377.184,435.171,367.738,440.894z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.685,108.055c-30.198-42.235-71.978-73.993-120.82-91.84c-10.375-3.792-21.859,1.546-25.649,11.921 c-3.791,10.375,1.546,21.858,11.921,25.649C414.989,84.791,472,166.055,472,256c0,42.589-12.665,84.044-36.626,119.885 c-6.139,9.183-3.672,21.603,5.511,27.742c3.415,2.283,7.276,3.375,11.097,3.375c6.453,0,12.789-3.118,16.644-8.886 C497.001,355.674,512,306.531,512,256C512,202.505,495.639,151.346,464.685,108.055z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg111PowerButton);
export default __webpack_public_path__ + "static/media/111-power-button.83f21a1799845be92f53089a832d298a.svg";
export { ForwardRef as ReactComponent };